export default __webpack_public_path__ + "static/media/deck.7d2ad3f3.webp";